import { Spinner } from '@change/ds-core-ui/Spinner';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { withPrefetchedData } from '#src/shared/prefetch';

import type { MiscContentDetailsPagePrefetchedDataProps } from '#src/app/pages/misc/pageContext';
import { MiscContentDetailsPageContextProvider, prefetchPageContext } from '#src/app/pages/misc/pageContext';
import { isLoaded } from '#src/app/shared/utils/async';

import { Layout } from '../layout';

import { MiscContentDetailsErrorHandler } from './ErrorHandler';

export const MiscContentDetails = withPrefetchedData(
	function MiscContentDetails({ prefetchedData }: MiscContentDetailsPagePrefetchedDataProps) {
		const { countryCode, slug } = useKnownAvailableParams<{ countryCode: string; slug: string }>();

		return (
			<MiscContentDetailsPageContextProvider
				slug={slug}
				countryCode={countryCode}
				prefetchedData={prefetchedData}
				errorHandler={MiscContentDetailsErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</MiscContentDetailsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.countryCode!, context.params.slug!, context),
		pageTitle: ({ prefetchedData, fromTemplate }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			return fromTemplate(prefetchedData.pageData.pageData.details.title);
		},
	},
);
